export var PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus["Available"] = "available";
    PropertyStatus["Reserved"] = "reserved";
    PropertyStatus["Sold"] = "sold";
    PropertyStatus["ComingSoon"] = "coming_soon";
})(PropertyStatus || (PropertyStatus = {}));
export var PropertyType;
(function (PropertyType) {
    PropertyType["House"] = "house";
    PropertyType["LokalMieszkalny"] = "lokal-mieszkalny";
    PropertyType["LokalUslugowy"] = "lokal uslugowy";
    PropertyType["Garaz"] = "garaz";
    PropertyType["Komorka"] = "komorka";
    PropertyType["MiejscePostojowe"] = "miejsce-postojowe";
    PropertyType["MiejscePodWiata"] = "miejsce-pod-wiata";
    PropertyType["BoksGarazowy"] = "boks-garazowy";
    PropertyType["NiezadaszoneMiejsceWylacznegoKorzystania"] = "niezadaszone-miejsce-wylacznego-korzystania";
})(PropertyType || (PropertyType = {}));
const RESIDENTIAL = {
    [PropertyType.House]: true,
    [PropertyType.LokalMieszkalny]: true,
    [PropertyType.LokalUslugowy]: false,
    [PropertyType.Garaz]: false,
    [PropertyType.Komorka]: false,
    [PropertyType.MiejscePostojowe]: false,
    [PropertyType.MiejscePodWiata]: false,
    [PropertyType.BoksGarazowy]: false,
    [PropertyType.NiezadaszoneMiejsceWylacznegoKorzystania]: false,
};
const GOV_REPORTABLE = {
    [PropertyType.House]: true,
    [PropertyType.LokalMieszkalny]: true,
    [PropertyType.LokalUslugowy]: false,
    [PropertyType.Garaz]: true,
    [PropertyType.Komorka]: true,
    [PropertyType.MiejscePostojowe]: true,
    [PropertyType.MiejscePodWiata]: true,
    [PropertyType.BoksGarazowy]: true,
    [PropertyType.NiezadaszoneMiejsceWylacznegoKorzystania]: true,
};
export class Property {
    constructor(data) {
        this.type = data.type;
        this.includeInGovReporting = data.includeInGovReporting;
    }
    get isResidential() {
        return RESIDENTIAL[this.type];
    }
    get isReportable() {
        return this.includeInGovReporting && GOV_REPORTABLE[this.type];
    }
}
//# sourceMappingURL=property.js.map